import Request from './request';
import store from "@/store";
import snackbar from "@/plugins/snackbar";
import i18n from "@/i18n";

async function fetchShop(data) {
    return Request('get', "api/settlements/shop-index", data);
}

async function fetchShopMaterial(id, data) {
    return Request('get', "api/settlements/shop-material-view/" + id, data);
}

async function fetchShopBill(id, data) {
    return Request('get', "api/settlements/shop-bill-view/" + id, data);
}

async function fetchPurchase(data) {
    return Request('get', "api/settlements/purchase-index", data);
}

async function fetchPurchaseMaterial(id, data) {
    return Request('get', "api/settlements/purchase-material-view/" + id, data);
}

async function fetchPurchaseBill(id, data) {
    return Request('get', "api/settlements/purchase-bill-view/" + id, data);
}

async function fetchRequisition(data) {
    return Request('get', "api/settlements/requisition-index", data);
}

async function fetchRequisitionMaterial(id, data) {
    return Request('get', "api/settlements/requisition-material-view/" + id, data);
}

async function fetchRequisitionBill(id, data) {
    return Request('get', "api/settlements/requisition-bill-view/" + id, data);
}

async function getMaterialListForPaginate(data) {
    return Request('get', "api/settlements/get-material-list-for-paginate", data);
}

async function getBillListForPaginate(data) {
    return Request('get', "api/settlements/get-billList-for-paginate", data);
}

async function getLogisticsBills(data) {
    return Request('get', "api/settlements/get-logistics-bills", data)
}

async function getServiceChargeBills(data) {
    return Request('get', "api/settlements/get-service-charge-bills", data)
}


async function getDetailByMaterial(settlementId, date) {
    return Request('get', "api/settlements/detail-by-material/" + settlementId, date);
}

async function getDetailByBill(settlementId, date) {
    return Request('get', "api/settlements/detail-by-bill/" + settlementId, date);
}

async function getShopWaitSettleBills(data) {
    return Request('get', "api/settlements/get-shop-wait-settle-bills", data);
}

async function getPurchaseWaitSettleBills(data) {
    return Request('get', "api/settlements/get-purchase-wait-settle-bills", data);
}

async function getRequisitionWaitSettleBills(data) {
    return Request('get', "api/settlements/get-requisition-wait-settle-bills", data)
}

async function updateUnsettledBill(data) {
    return Request('post', "api/settlements/update-unsettled-bill", data)
}

async function getUnsettledBills(data) {
    return Request('get', "api/settlements/get-unsettled-bills", data)
}

async function addQueue(data) {
    return Request('post', "api/settlements/add-queue", data)
}

async function queueIndex(data) {
    return Request('get', "api/settlements/queue-index", data)
}

async function queueBills(data) {
    return Request('get', "api/settlements/queue-bills", data)
}

async function shopDetailExport(id) {
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/settlements/shop-detail-export/" + id);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

async function requisitionDetailExport(id) {
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/settlements/requisition-detail-export/" + id);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

async function purchaseDetailExport(id) {
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/settlements/purchase-detail-export/" + id);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

async function queueRegenerate(id) {
    return Request('get', "api/settlements/queue-regenerate/" + id)
}

async function queueCancel(id) {
    return Request('get', "api/settlements/queue-cancel/" + id)
}

async function getBillRelatedImg(billId) {
    return Request('get', "api/settlements/get-bill-related-img/" + billId)
}

async function shopCheck(id) {
    return Request('get', "api/settlements/shop-check/" + id)
}

async function requisitionCheck(id) {
    return Request('get', "api/settlements/requisition-check/" + id)
}

async function purchaseCheck(id) {
    return Request('get', "api/settlements/purchase-check/" + id)
}


export default {
    fetchShop,
    fetchShopMaterial,
    fetchShopBill,
    fetchPurchase,
    fetchPurchaseMaterial,
    fetchPurchaseBill,
    fetchRequisition,
    fetchRequisitionMaterial,
    fetchRequisitionBill,
    getMaterialListForPaginate,
    getBillListForPaginate,
    getLogisticsBills,
    getServiceChargeBills,
    getDetailByMaterial,
    getDetailByBill,
    getShopWaitSettleBills,
    getPurchaseWaitSettleBills,
    getRequisitionWaitSettleBills,
    updateUnsettledBill,
    getUnsettledBills,
    addQueue,
    queueIndex,
    queueBills,
    shopDetailExport,
    requisitionDetailExport,
    purchaseDetailExport,
    queueRegenerate,
    queueCancel,
    getBillRelatedImg,
    shopCheck,
    requisitionCheck,
    purchaseCheck,
};